module.exports = __webpack_public_path__ + "img/diesel-locomotive-01.7e7f2a5e.png";